export default {
  namespaced: true,
  charts_embedder: {
    loading: "Cargando...",
    select_to_begin: "Selecciona un dataset y una vista para comenzar.",
    copy: "Copiar",
    apply: "Aplicar",
    settings: "Configuración",
    dataset: "Dataset",
    view: "Vista",
    language: "Idioma",
    time_range: "Rango de tiempo",
    custom_date: "Rango de fechas personalizado",
    from: "Desde",
    to: "Hasta",
    select_date: "Seleccionar fecha...",
    advanced_filters: "Filtros avanzados",
    live: "En vivo",
  },
};
